/**
 * Route level decorator that mounts the application-wide FeatureFlagsProvider.
 *
 * It sits above Master so that Master itself, and every page rendered inside
 * it, share ONE Statsig client — same user, same readiness state, same
 * timeout. Without this, each call site created its own client and the
 * routing decisions in Master could disagree with the ones made by the page
 * it rendered (e.g. src/pages/home/Layout.js).
 */

import React from 'react';
import PropTypes from 'prop-types';
import { Outlet } from 'react-router-dom';
import { useConnect } from '@lore/query-connect';

import FeatureFlagsProvider from '../context/FeatureFlagsProvider';

WithFeatureFlags.propTypes = {
  children: PropTypes.node
};

export default function WithFeatureFlags(props) {
  const { children } = props;

  // Same cached singleton Master subscribes to, so this doesn't add a request.
  const currentUser = useConnect('currentUser.singleton');

  return (
    <FeatureFlagsProvider currentUser={currentUser}>
      {children || <Outlet/>}
    </FeatureFlagsProvider>
  );
};
